import { REDUCER_NAME } from './const'
import { selectOwnState as selectParentState } from '../selector'

export const selectOwnState = state => {
    return selectParentState(state)[REDUCER_NAME]
}

export const selectIsFetching = state => {
    return selectOwnState(state).fetching
}

export const selectImageVersionList = state => {
    return selectOwnState(state).imageVersionList
}

const getOverwrittenImageType = (imageType, imageVersion) => {
    if (!imageVersion.meta) {
        return imageType
    }
    if (!imageVersion.meta.imageType) {
        return imageType
    }
    return imageVersion.meta.imageType
}

const handleVersionList = (versionList, fileName, imageVersionListSorted) => {
    versionList.forEach(imageVersion => {
        const overwrittenImageType = getOverwrittenImageType(
            fileName,
            imageVersion
        )
        if (!imageVersionListSorted[overwrittenImageType]) {
            imageVersionListSorted[overwrittenImageType] = []
        }
        imageVersion.originalImageType = fileName
        imageVersionListSorted[overwrittenImageType].push(imageVersion)
    })
}

export const selectOrderedImageVersionList = state => {
    const imageVersionList = selectImageVersionList(state)

    const imageVersionListSorted = {}

    for (const fileName in imageVersionList) {
        const versionList = imageVersionList[fileName]
        handleVersionList(versionList, fileName, imageVersionListSorted)
    }
    return imageVersionListSorted
}

export const selectImageVersion = (state, fileName) => {
    const imageVersionList = selectOwnState(state).imageVersionList
    return imageVersionList ? imageVersionList[fileName] : null
}

export const selectVersionImageVersion = (state, fileName, versionId) => {
    const imageVersion = selectImageVersion(state, fileName)
    if (!imageVersion) {
        return null
    }
    for (let index = 0; index < imageVersion.length; index++) {
        const current = imageVersion[index]
        if (current.versionId === versionId) {
            return current
        }
    }
    return null
}

export const selectShowImages = state => {
    return selectOwnState(state).showImages
}

export const selectUploadingImages = state => {
    return selectOwnState(state).uploadingImages
}

export const selectRetryImages = state => {
    return selectOwnState(state).retryImages
}

export const selectSelectedImageType = state => {
    return selectOwnState(state).selectedImageType
}

export const selectCurrentStep = state => {
    return selectOwnState(state).currentStep
}

export const selectSlideIndex = state => {
    return selectOwnState(state).slideIndex
}



// WEBPACK FOOTER //
// ./src/modules/customer/state/image/selector.js